import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Card, Form, Row, Col, Button, Table } from 'react-bootstrap';
import { PlusLg } from 'react-bootstrap-icons';
import { MonetaryFloatInput } from '../../../../components/common/MonetaryFloatInput';
import Required from '../../../../components/Required';
import { makeUID } from '../../../../helpers';

export default function PortfolioProjectBudget({ periods, finSources, data, portfolioPlans, onChange, options, disabled }) {
  const addPlan = () => {
    onChange([...data, {id: 0, hash: makeUID(5), type: 'fb'}], 'plans')
  };

  const closedPeriods = useMemo(()=> periods.filter(x=> x.isClosed).map(element => element.year),[periods,data,options])

  const updatePlan = (planToEdit, updatedPlan) => {
    onChange(data.map(p => {
      if(planToEdit.id)
        return p.id === planToEdit.id ? {...p, ...updatedPlan} : p;
      else 
        return p.hash === planToEdit.hash ? {...p, ...updatedPlan} : p;
    }));
  };

  const removePlan = (planToRemove) => {
    onChange(data.filter(p => planToRemove.id ? p.id !== planToRemove.id : p.hash !== planToRemove.hash));
  };

  const toggleType = (e, plan) => {
    updatePlan(plan, { type: e.target.value, portfolioPlanId: undefined });
  };

  const handleOptionSelect = (planToEdit, portfolioPlanId) => {
    if(!portfolioPlanId) {
      updatePlan(planToEdit, { portfolioPlanId: undefined });
    } else {
      const foundPortfolioPlan = portfolioPlans.find(pp => pp.id === parseInt(portfolioPlanId));
    
      if(foundPortfolioPlan)
        updatePlan(planToEdit, { portfolioPlanId: parseInt(portfolioPlanId) });
    }

    
  };

  const handleSumChange = (planToEdit, sum) => {
    updatePlan(planToEdit, {...planToEdit, sum, });
  }

  const getOptions = (portfolioPlanId, type,i) => {
    const selectedPortfolioPlanIds = data.map(d => d.portfolioPlanId).filter(id => id);
    return options
      .filter(v => v.type === type && (!selectedPortfolioPlanIds.includes(v.id) || portfolioPlanId) && (selectedPortfolioPlanIds.includes(v.id) || !closedPeriods.includes(v.year)))
      .map((v, i) => <option key={v.id} value={v.id}>{v.label}</option>)
  }

  return (
    <Card className="mb-4">
      <Card.Header as={Card.Title} className="p-4">
        Бюджет
      </Card.Header>
      <Card.Body className="p-4">
        {data.map((item, index) => {
          const isItemEnabled = !item.year;

          return (
            <Row key={index}>
              <Form.Group as={Col}>
                <Card className="mb-4">
                  <Card.Header style={cardHeaderStyling}>
                    {isItemEnabled && data.length > 1 && (
                      <Button
                        onClick={() => removePlan(item)}
                        variant="light"
                        className="btn-close"
                        size="sm"
                      />
                    )}
                  </Card.Header>
                  <Card.Body>
                    <Row className="mb-4">
                      <Form.Group as={Col} md="12">
                        {finSources.map(({type, title}) => (
                          <Form.Check
                            type="radio"
                            name={`typeGroup-${item.id || item.hash}-${type}`}
                            inline
                            label={title}
                            value={type}
                            onChange={(e) => toggleType(e, item)}
                            checked={item.type === type}
                            key={type}
                            disabled={disabled}
                          />
                        ))}
                      </Form.Group>
                    </Row>
                    <Row className="mb-4">
                      <Form.Group as={Col} md="6">
                        <Form.Label>
                          Источник <Required />
                        </Form.Label>
                        <Form.Control
                          required
                          as="select"
                          readOnly={closedPeriods.includes(item.year)}
                          value={item.portfolioPlanId}
                          onChange={(e) => handleOptionSelect(item, e.target.value)}
                          disabled={disabled}
                        >
                          <option value={null}></option>
                          {getOptions(item.portfolioPlanId, item.type)}
                          {/* {finSources['fb'] && finSources['fb'].sources.bcCodes.map(c => <option key={c.id} value={c.id}>{c.fullCode}</option>)} */}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          Выберите источник
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md="6">
                        <Form.Label>
                          План, руб <Required />
                        </Form.Label>
                        <MonetaryFloatInput
                          required
                          readOnly={closedPeriods.includes(item.year) || disabled}
                          value={item.sum}
                          onChange={(value) =>
                            handleSumChange(item, value)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          Введите сумму
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                  </Card.Body>
                </Card>
              </Form.Group>
            </Row>
          );
        })}
        <Row>
          <Form.Group as={Col} md="12">
            <Button disabled={disabled} onClick={addPlan} variant='outline-primary'><PlusLg className="me-1 mb-1"/>Добавить</Button>
          </Form.Group>
        </Row>
      </Card.Body>
    </Card>
  );
}

const cardHeaderStyling = {
  display: 'flex',
  justifyContent: 'end',
  minHeight: 38,
};
